<style scoped lang="less">
@import "./assets/style.less";
</style>

<script>
export default {
  name: "mongolianLang",
  props: ['tableData', 'ifRepeatLock', 'bCb', 'queryData', 'isSourceid'],
  data () {
    return {
      eleHeight: '684px',
      width: '100%',
      currentId: null,
    };
  },

  comments () {

  },
  //生命周期
  mounted () {
    let eleWrapHeight = parseInt(window.getComputedStyle(this.$refs.ele).height) - (40 + 48 + 48 + 30);
    this.eleHeight = `${eleWrapHeight}px`;
    const dom = document.getElementsByClassName('last-tgt-mno');
    console.log(dom);
    this.$nextTick(() => {
      console.log(!!dom);
      for (let i = 0; i < dom.length; i++) {
        console.log(dom[i]);
      }
    })

  },
  watch: {
    ifRepeatLock: {
      //深度监听，可监听到对象、数组的变化
      handler (newV, oldV) {
        console.log(newV);
        console.log(oldV)
      },
      deep: true,
    },
    isSourceid: {
      //深度监听，可监听到对象、数组的变化
      handler (newV, oldV) {
        console.log(newV);
        console.log(oldV)
      },
      deep: true,
    },
  },
  // 方法
  methods: {
    //左右原文和译文对应的方法
    pitchOn: function (e, item, number) {
      this.$emit("pitchOn", e, item, number)
    },

    sourceChangeText: function (e, item, isSourceid) {
      this.$emit("sourceChangeText", e, item);
      if (!!isSourceid) {
        let targetId = e.currentTarget.id;
        let srcDom = document.getElementById(targetId);
        return new Promise((resolve) => {
          srcDom.style.width = `100%`;
          resolve(true)
        }).then(() => {
          setTimeout(() => {
            srcDom.style.width = '';
          }, 500)
        });
      }
    },

    // item可能是当前行数据或者是源语言和目标语言
    onFocus: function (e, item) {
      this.$emit("onFocus", e, item)
    },

    sourceBlur: function (e, item) {
      this.$emit("sourceBlur", e, item)
    },

    getCursortPosition: function (e, item) {
      this.$emit("getCursortPosition", e, item)
    },

    oncontextmenu: function (item, e) {
      this.$emit("oncontextmenu", item, e)
    },


    AutoComple: function (e, item) {
      this.$emit("AutoComple", e, item);
      let targetId = e.currentTarget.id;
      const tgtDom = document.getElementById(targetId);
      return new Promise((resolve) => {
        tgtDom.style.width = `100%`;
        resolve(true)
      }).then(() => {
        setTimeout(() => {
          tgtDom.style.width = '';
        }, 100)
      });
    },

    blurText: function (e, item) {
      this.$emit("blurText", e, item)
    },

    getHint: function (e) {
      this.$emit("getHint", e)
    },

    enterKey: function (e, item) {
      this.$emit("enterKey", e, item)
    },

    //添加备注时间
    onAddPostil: function (item, number) {
      this.$emit("onAddPostil", item, number)
    },

    // 判断重复句段是否锁定
    repeatLock (row) {
      return (!this.ifRepeatLock && (row.sameFileSentNo || row.sameProjectSentNo)) || (row.unlockStatus === 1 && row.contentEditable)
    },

    statusTit (item) {
      this.$emit('statusTit', item)
    },

    onAddPostil (item, number) {
      this.$emit('onAddPostil', item, number)
    },


    //属于借口的调用
    homologous (item) {
      this.currentId = (item.id);
      this.$emit('homologous', item)
    },

    getInfo (id) {
      // console.log(`${id}`);
      // console.log(this.$refs[`${id}`])
    }
  }
}
</script>

<template>
  <div class="mongolian_wrap" ref="ele" :class="{ theme: bCb}" id="tab1">
    <template v-if="(!!tableData.length)">
      <div class="mongolian_Lang" v-for="(item,index) in tableData" :key="item.id"
           :class="{'mongolian_Lang_active': (currentId===(item.id))}" ref="refTable">
        <!--ES8补白-->
        <!--{{item}}-->
        <div @click="homologous(item)">
          <!--{{(index+1).toString().padStart(2, '0')}}-->
          <div class="first">{{(index+1)}}</div>
          <div class="second" title="批注">
            <i class="updateBox" v-show="item.commentType===3"
               @click.stop="onAddPostil(item,5)"></i>
            <i class="addBox" v-show="item.commentType!==3" @click.stop="onAddPostil(item,4)"></i>
          </div>
          <div class="third" title="状态">
            <i v-if="(item.contentEditable === 1 || repeatLock(item))"
               :class="item.status<2 ? 'modify' : 'confirm'"></i>

            <i v-else class="lock" :title="statusTit(item)"></i>

          </div>
          <div class="last" :style="{height:eleHeight}">
            <p type="source" :sId="item.id" :id="'source-'+item.id" :ref="'source-'+item.id"
               class="txt sourceSentBox"
               :class="((queryData.sourceLang)==='mno')?'last-tgt-mno':'last-src'"
               v-html="item.sourceSent" v-on:keydown.enter.prevent
               :info="getInfo('source-'+item.id)"
               :contenteditable="((item.contentEditable) || repeatLock(item)) ? 'true' :null"
               @mouseup="pitchOn($event,item)" @input="sourceChangeText($event,item,isSourceid)"
               @focus="onFocus($event,'source')" @blur="sourceBlur($event,item)"
               @click="getCursortPosition($event,item)" @contextmenu="oncontextmenu(item,$event)"
               @keyup.enter="sourceBlur($event,item)">
            </p>
            <p :sId="item.id" :id="'target-'+item.id" type="target"
               class="txt last-src targetSentBox"
               :class="{'last-tgt-mno': (queryData.targetLang)==='mno','nav-link':true}"
               contenteditable="true" v-html="item.targetSent" :uid="item.transUserId"
               :sourceMd516="item.sourceMd516"
               :contenteditable="((item.contentEditable) || repeatLock(item)) ? 'true' :null"
               @click="getHint($event)" @focus="onFocus($event,item)" @blur="blurText($event,item)"
               @input="AutoComple($event,item)" @keydown="enterKey($event,item)"
               @mouseup="pitchOn($event,item,1)" @contextmenu="oncontextmenu(item,$event)">
            </p>
          </div>
        </div>

      </div>
    </template>

    <div v-else class="mongolian_Lang-empty">暂无数据</div>

  </div>

</template>